import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { Lot } from '../../../../types/lot/lot';
import { t } from '../../../../types/translation/Translator';
import React from 'react';
import LotInfoModalPane from './LotInfoModalPane';
import { ActionModal } from '../../../components/Modal';

interface CreateLotModalInputProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCreated?: (lot: Lot) => void;
  pmdId?: string;
}

export default function CreateLotModal({ open, setOpen, onCreated, pmdId }: CreateLotModalInputProps) {
  return (
    <ActionModal open={open} setOpen={setOpen} title={t(TranslationKey.createNewLot).singular.upper}>
      <LotInfoModalPane setOpen={setOpen} onCreated={onCreated} pmdId={pmdId} />
    </ActionModal>
  );
}
